import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'CREATE_DYNAMIC_PROFILE',
    'FETCH_DYNAMIC_PROFILE_LIST',
    'FETCH_DYNAMIC_PROFILE_LIST_SUCCESS',
    'FETCH_DYNAMIC_PROFILE',
    'FETCH_DYNAMIC_PROFILE_SUCCESS',
    'UPDATE_DYNAMIC_PROFILE',
    'DELETE_DYNAMIC_PROFILE'
], 'DYNAMIC_PROFILE');

// Action Creators
export const createDynamicProfileForm = createFormAction(actions.CREATE_DYNAMIC_PROFILE);
export const updateDynamicProfileForm = createFormAction(actions.UPDATE_DYNAMIC_PROFILE);
export const fetchList = createAction(actions.FETCH_DYNAMIC_PROFILE_LIST);
export const fetchListSuccess = createAction(actions.FETCH_DYNAMIC_PROFILE_LIST_SUCCESS);
export const fetchDynamicProfile = createAction(actions.FETCH_DYNAMIC_PROFILE);
export const fetchDynamicProfileSuccess = createAction(actions.FETCH_DYNAMIC_PROFILE_SUCCESS);
export const deleteDynamicProfile = createAction(actions.DELETE_DYNAMIC_PROFILE);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    dynamicProfile: {}
};

export default handleActions({
    [actions.FETCH_DYNAMIC_PROFILE_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_DYNAMIC_PROFILE_SUCCESS]: (state, action) => {
        const updatedData = {
            dynamicProfile: { $set: action.payload }
        };
        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/dynamicProfiles/duck.js